export default {
  execStartLoading ({ commit }) {
    commit('setIsLoading', true);
  },
  execStopLoading ({ commit }) {
    commit('setIsLoading', false);
  },
};
